import firebase from "firebase/compat/app";
import 'firebase/compat/storage';
import 'firebase/compat/database';
import 'firebase/compat/auth';
import "firebase/compat/firestore";
import "firebase/compat/functions";

export const app = firebase.initializeApp({
    apiKey: "AIzaSyCvWcbz4uH7d2--TChjGOQls3_ZqCZKgvs",
    authDomain : "wet-data.firebaseapp.com",
    projectId : "wet-data",
    storageBucket : "wet-data.appspot.com",
    messagingSenderId : "921323999410",
    appId : "1:921323999410:web:0a5493c2de1433491eb9ab",
    measurementId : "G-JV2K8BJT82",
    databaseURL : "https://wet-data-default-rtdb.europe-west1.firebasedatabase.app"
})